<template>
    <div class="main-table__data">
        <div class="image-block">
            <img :src="LogoHelper.getLogo(columnData.logoUrl)" alt="">
        </div>

        <div class="pr-3">
            <h5 class="heading5">
                <a v-if="addData.companyType == 'startups'" target="_blank" :href="'/startups/' + columnData.id">{{ columnData.name }}</a>
                <a v-if="addData.companyType == 'ecosystems'" target="_blank" :href="'/ecosystems/' + columnData.id">{{ columnData.name }}</a>
                <span v-if="addData.companyType == 'enterprises'">{{ columnData.name }}</span>
            </h5>
            <p v-if="addData.companyType != 'enterprises'">
                <span class="line-clamp">{{columnData.shortDescription}}</span>
                <a @click="getStartupDetails" class="link" :id="'details-link-'+ addData.companyType + '-' + rowId">(more)</a>
            </p>
        </div>
        <div class="main-table__connection">
        <template v-if="addData.companyType == 'ecosystems' && typeof columnData.connect_status !== 'undefined' ">
            <template v-if="columnData.connect_status == 'new'">
                <span class="main-table__connection__sent">Invite Sent</span>
            </template>
            <template v-else-if="columnData.connect_status == 'accepted'">
                <span class="main-table__connection__success">Connected</span>
            </template>
            <template v-else-if="columnData.connect_status == 'rejected'">
                <span class="main-table__connection__rejected">Invite Rejected</span>
            </template>
            <template v-else>
                <a class="link" @click="$emit('action', {action: 'invite-ecosystem', rowId: columnData.id})">+ Connect</a>
            </template>
        </template>
        </div>
        
        <template v-if="typeof columnData.hasTrackers !== 'undefined' && columnData.hasTrackers">
            <a :id="'trackers-link-'+rowId" class="counter-wrapper">
                <span @click="getStartupDetails" class="counter">
                    <template v-if="trackersCount > 0">{{trackersCount}}</template>
                    <template v-else>+</template>
                </span>
            </a>
        </template>

        <b-popover ref="details" :target="'details-link-'+ addData.companyType + '-' + rowId">
            <div class="popover__content" v-click-outside="closeDetailsPopover">
                <header class="popover__content__header">
                    <div class="popover__content__side">
                        <img class="main-table__logo" :src="LogoHelper.getLogo(columnData.logoUrl)" alt="">
                    </div>
                    <div>
                        <h4 class="heading4">
                            <a v-if="addData.companyType == 'startups'" target="_blank" :href="'/startups/' + columnData.id">{{ columnData.name }}</a>
                            <a v-if="addData.companyType == 'ecosystems'" target="_blank" :href="'/ecosystems/' + columnData.id">{{ columnData.name }}</a>
                        </h4>
                        <p>{{startupDetails.description}}</p>
                    </div>
                </header>

                <div class="popover__content__body" v-if="startupDetails.website">
                    <div class="popover__content__side">
                        <h6 class="heading6">Website:</h6>
                    </div>
                    <div>
                        <p>
                            <a :href="startupDetails.website" target="_blank">{{startupDetails.website}}</a>
                        </p>
                    </div>
                </div>

                <template v-if="addData.companyType == 'startups' && $store.state.user.company_type == 'enterprise'">
                    <div class="popover__content__body">
                        <div class="popover__content__side">
                            <h6 class="heading6">Trackers:</h6>
                        </div>
                        <div>
                            <p>
                                <span v-for="(tracker, index) in startupDetails.trackers" :key="tracker.id">
                                    <a :href="'/trackers/' + tracker.id" target="_blank">{{ tracker.name }}</a>
                                    <template v-if="index < startupDetails.trackers.length - 1">, </template>
                                </span>
                            </p>
                        </div>
                    </div>

                    <div class="popover__content__body">
                        <div class="popover__content__side">
                            <h6 class="heading6">Tags:</h6>
                        </div>
                        <div class="tags-list">
                            <span v-for="tag in startupDetails.tags" :key="tag.id" class="tags-list__tag" :title="tag.name">
                                <a @click="tagClicked(tag)">{{ tag.name }}</a>
                                <span @click="removeTag(tag.id)" class="tags-list__tag__close"></span>
                            </span>

                            <a v-if="!showAddTags" @click.stop="showAddTags = true; getTagsList()" class="tags-list__add">+ Add</a>

                            <multiselect v-if="showAddTags"
                                v-model="addedTags"
                                :multiple="true"
                                :options="tagsList"
                                select-label=""
                                deselect-label=""
                                label="name"
                                track-by="name"
                                class="multiselect-mid pl-2"
                            >
                            </multiselect>

                            <template v-if="showAddTags">
                                <div class="d-flex justify-content-end w-100">
                                    <a @click="showAddTags = false" class="btn btn-cancel">Cancel</a>
                                    <a v-if="addedTags.length" @click="addTags" class="btn btn-primary ml-3">+ Add Tags</a>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </b-popover>

        <b-popover v-if="$store.state.user.company_type == 'enterprise' && columnData.hasTrackers" ref="trackersPopover" :target="'trackers-link-'+rowId" placement="bottomright">
            <div class="popover__content popover__content--secondary" v-click-outside="closeTrackersPopover">
                <header class="popover__content__header">
                    <h4 class="heading4">Add to tracker</h4>

                    <a @click="$emit('action', {action: 'add-tracker', rowId: columnData.id})" class="link">Create New</a>
                </header>

                <div class="popover__content__body flex-column">
                    <multiselect
                        class="multiselect multiselect-mid"
                        v-model="addedTracker"
                        :options="addData.trackersList"
                        select-label=""
                        deselect-label=""
                        label="name"
                        track-by="name"
                    >
                    </multiselect>

                    <h4 class="heading4 mt-4" v-if="startupDetails.trackers.length">
                        On {{startupDetails.trackers.length}} tracker(s)
                    </h4>

                    <ul class="rows-list">
                        <li v-for="tracker in startupDetails.trackers" :key="tracker.id">
                            <h5 class="heading5 heading5--secondary"><a :href="'/trackers/' + tracker.id" target="_blank">{{ tracker.name }}</a></h5>
                            <a v-if="tracker.type != 'public'" @click="removeFromTracker(tracker.id)" class="link-remove">Remove</a>
                        </li>
                    </ul>

                </div>
            </div>
        </b-popover>
    </div>
</template>

<script>

import enterpriseStartups from "../../services/startups.service";
import ecosystemStartups from "../../services/ecosystem/startups.service";
import ecosystems from "../../services/ecosystems.service";
import multiselect from 'vue-multiselect'
import tags from '../../services/tags.service'
import trackersStartups from "../../services/trackers-startups.service";

export default {
    props: {
        columnData: {
            'name': String,
            'logoUrl': String,
            'trackersCount': Number,
            'shortDescription': String,
            'hasTrackers': {
                type: String,
                default: false
            },
        },

        addData: Object,
        rowId: Number
    },
    components: {
        multiselect,
    },
    data() {
        return {
            startupDetails: {
                description: '',
                tags: [],
                trackers: [],
            },

            tagsList: [],
            addedTags: [],
            addedTracker: null,
            trackersCount: 0,

            showAddTags: false,
        }
    },

    watch: {
        addedTracker() {
            if (this.addedTracker != null) {
                this.addToTracker()
            }
        },
        columnData: {
            "deep": true,
            handler() {
                if (typeof this.columnData.trackersCount !== "undefined") {
                    this.trackersCount = this.columnData.trackersCount
                }
            }
        }
    },
    computed: {
        logoUrl() {
            if (this.columnData.logoUrl) {
                return this.columnData.logoUrl
            }
            else {
                return require('../../images/' + this.defaults.startupLogo)
            }
        }
    },
    mounted() {
        if (typeof this.columnData.trackersCount !== "undefined") {
            this.trackersCount = this.columnData.trackersCount
        }
    },
    methods: {
        getStartupDetails() {
            if (this.addData.companyType == "ecosystems") {
                ecosystems.getDetails(this.columnData.id).then(response => {
                    this.startupDetails = response.data
                })
            }
            else {
                if (this.$store.state.user.company_type == 'ecosystem') {
                    ecosystemStartups.getDetails(this.columnData.id).then(response => {
                        this.startupDetails = response.data
                    })
                }
                else {
                    enterpriseStartups.getDetails(this.columnData.id).then(response => {
                        this.startupDetails = response.data
                        this.trackersCount = this.startupDetails.trackers.length
                    })
                }
            }
        },

        closeDetailsPopover() {
            this.cancelAddTags()
            this.$refs.details.$emit('close')
        },

        showTrackersDetails() {
            enterpriseStartups.getDetails(this.columnData.id).then(response => {
                this.startupDetails = response.data
            })
        },

        closeTrackersPopover() {
            this.$refs.trackersPopover.$emit('close')
        },

        cancelAddTags() {
            this.showAddTags = false
            this.addedTags = []
        },

        getTagsList() {
            if (!this.tagsList.length) {
                tags.getList().then(response => {
                    this.tagsList = response.data
                })
            }
        },

        addTags() {
            let addedTags = this.arrayHelper.arrayColumn(this.addedTags, 'value')
            let startups = [this.columnData.id]
            tags.addTags(startups, addedTags).then(() => {
                this.cancelAddTags()
                this.getStartupDetails()
            })
        },

        removeTag(tagId) {
            let removedTags = [tagId]
            let startups = [this.columnData.id]
            tags.removeTags(startups, removedTags).then(() => {
                this.getStartupDetails()
            })
        },

        addToTracker() {
            let addedTrackers = [this.addedTracker.value]
            let startups = [this.columnData.id]
            trackersStartups.addStartups(startups, addedTrackers).then(() => {
                this.getStartupDetails()
                this.addedTracker = null
            })
        },

        removeFromTracker(trackerId) {
            let removedTrackers = [trackerId]
            let startups = [this.columnData.id]
            trackersStartups.removeStartups(startups, removedTrackers).then(() => {
                this.getStartupDetails()
            })
        },

        tagClicked(tag) {
            if (typeof this.addData.fromSearch != "undefined") {
                this.$emit('action', {action: 'tag-clicked', tagName: tag.name})
            }
            else {
                this.$router.push('/startups?tag=' + tag.name)
            }
        }
    }
}
</script>

<style scoped>

</style>